var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" "),(_vm.supportClose)?_c('i',{class:{
        'el-icon-close close': !_vm.enterClose,
        'el-icon-error close hover-close': _vm.enterClose,
      },staticStyle:{"height":"24px","line-height":"24px","margin":"0px 0px 0px 5px"},on:{"click":function($event){$event.stopPropagation();return _vm.onClose.apply(null, arguments)},"mouseenter":() => (_vm.enterClose = true),"mouseleave":() => (_vm.enterClose = false)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }